import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";
import NoteAddOutlined from "@mui/icons-material/NoteAddOutlined";
import HistoryOutlined from "@mui/icons-material/HistoryOutlined";
import GroupRemoveOutlined from "@mui/icons-material/GroupRemoveOutlined";
import PersonOutlined from "@mui/icons-material/PersonOutlined";
import React from "react";

export type JobMenuItem = {
  label: string;
  key: string;
  icon?: React.ReactNode;
  danger?: boolean;
};

export const getGraphBackgroundColor = (grade: number): string => {
  switch (grade) {
    case 0:
    case 1:
      return "#ffe0e6";
    case 2:
      return "#ffecb3";
    case 3:
      return "#dbf2f2";
    case 4:
      return "#d7ecfb";
    default:
      return "#ffffff";
  }
};

export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

export const calculateHours = (
  startTime: string,
  endTime: string
): number => {
  const [startHours, startMinutes] = startTime.split(":").map(Number);
  const [endHours, endMinutes] = endTime.split(":").map(Number);

  let start = startHours * 60 + startMinutes;
  let end = endHours * 60 + endMinutes;

  if (end < start) {
    end += 24 * 60;
  }

  return (end - start) / 60;
};

export const colors = [
  "#444c5c",
  "#ce5a57",
  "#78a5a3",
  "#e1b16a",
  "#aaaaaa",
  "#efc070",
  "#A2C4C9",
  "#8E7CC3",
  "#D5A6BD",
  "#EA9999",
];

export const getRandomColor = (): string => {
  return colors[Math.floor(Math.random() * colors.length)];
};

export const getInitials = (
    name?: string,
    surname?: string
): string => {
    return `${name?.[0] ?? ""}${surname?.[0] ?? ""}`.toUpperCase();
};

const workTypeLabels: Record<string, string> = {
  "Price Work": " (PW)",
  "X Other": " (X)",
  Labour: " (L)",
};

export const getTypeofWork = (typeOfWork?: string): string => {
  return workTypeLabels[typeOfWork ?? ""] ?? "";
};

const tierStatusLabels: Record<number, string> = {
  [-1]: "No Tier",
  0: "Active - Currently resourced on live shift",
  1: "Tier 1 - Not Working / Available < 24 hours",
  2: "Tier 2 - Working Available < 7 days",
  3: "Tier 3 - Not looking for work currently",
  4: "Tier 4 - Weekend Worker",
  5: "Tier 5 - Wrong or missing contact details",
};

export const getTierStatus = (tierStatus: number): string => {
  return tierStatusLabels[tierStatus] ?? "Unknown";
};

export const jobMenuItems: JobMenuItem[] = [
  {
    label: "Edit",
    key: "1",
    icon: <EditOutlined fontSize="small" />,
  },
  {
    label: "Workers",
    key: "2",
    icon: <PersonOutlined fontSize="small" />,
  },
  {
    label: "Duplicate",
    key: "3",
    icon: <NoteAddOutlined fontSize="small" />,
  },
  {
    label: "Copy",
    key: "4",
    icon: <GroupRemoveOutlined style={{ fontSize: 16 }} />,
  },
  {
    label: "History",
    key: "5",
    icon: <HistoryOutlined fontSize="small" />,
  },
  {
    label: "Delete",
    key: "6",
    icon: <DeleteOutlined fontSize="small" />,
    danger: true,
  },
];
